import PropTypes from 'prop-types';
import React from 'react';

/**
 *  FormElementHelp renders the help section to a form element, such as Input, Checkbox, etc
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function FormElementHelp(_ref) {
  let {
    help
  } = _ref;
  return !!help && /*#__PURE__*/_jsx("span", {
    "data-cmp": "form-element-help",
    className: "help-block",
    children: help
  }, "form-element-help");
}
export default FormElementHelp;